import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { FullPageStatus, LoginPage } from "../features/auth/login-page.js";
import { ProtectedRoute } from "../features/auth/protected-route.js";
import { SignupPage } from "../features/auth/signup-page.js";
import { VerifyEmailPage } from "../features/auth/verify-email-page.js";
import { ActivityDetailPage } from "../features/activities/activity-detail-page.js";
import { ActivityEditorPage } from "../features/activities/activity-editor-page.js";
import { ActivitySchedulePage } from "../features/activities/activity-schedule-page.js";
import { CalendarPage } from "../features/calendar/calendar-page.js";
import { FlashcardsPage } from "../features/flashcards/flashcards-page.js";
import { LibraryPage } from "../features/library/library-page.js";
import { PrivacyPage } from "../features/privacy/privacy-page.js";
import { TermsPage } from "../features/terms/terms-page.js";
import { TodayPage } from "../features/today/today-page.js";
import { NotFoundPage } from "../features/settings/not-found-page.js";
import { SettingsPage } from "../features/settings/settings-page.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export function App(): React.JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Suspense fallback={<FullPageStatus message="Preparing MemoKite…" />}>
          <Routes>
            <Route path="/" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/today" element={<TodayPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/library" element={<LibraryPage />} />
              <Route path="/flashcards" element={<FlashcardsPage />} />
              <Route path="/activities/new" element={<ActivityEditorPage mode="create" />} />
              <Route
                path="/activities/:activityId/edit"
                element={<ActivityEditorPage mode="edit" />}
              />
              <Route path="/activities/:activityId" element={<ActivityDetailPage />} />
              <Route path="/activities/:activityId/schedule" element={<ActivitySchedulePage />} />
              <Route path="/activities/*" element={<NotFoundPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
